// import {
//     BedDouble,
//     BriefcaseBusiness,
//     Calendar,
//     CalendarDays,
//     Car,
//     Circle,
//     Clock,
//     Compass,
//     DollarSign,
//     Languages,
//     MapPin,
//     PersonStanding,
//     Search,
//     Star,
//     ToggleLeft,
//     UserRound,
//   } from "lucide-react";

//   function StaysComponent() {
//     return (
//       <div className="border border-[rgba(85,81,81,0.8)] flex flex-col md:flex-row justify-between items-start md:items-center gap-6 p-4 rounded my-4">
//         <img
//           src="/images/house1.png"
//           alt="Google"
//           className="rounded w-full md:w-[30%] object-cover"
//         />

//         <div className="flex flex-col w-full md:w-[70%] gap-6 justify-between">
//           <div className="flex flex-col sm:flex-row sm:justify-between gap-2">
//             <p className="text-[#570033] text-xl font-semibold">2-Bedroom Apartment in Lekki</p>
//             <span className="flex items-center gap-2 text-sm">
//               <Star className="text-yellow-400" size={18} />
//               <p className="text-[#570033] font-medium">4.8 (85 reviews)</p>
//             </span>

//             {/* <span className="flex items-center gap-2 text-sm">
//               <Circle className="text-[#006F00]" size={18} />
//               <p className="text-[#006F00] italic">Available</p>
//             </span> */}
//           </div>

//           <p className="text-[#666666] text-sm leading-relaxed">
//           Enjoy a peaceful escape in this well-furnished apartment tucked away in vibrant Lekki. Ideal for short stays or weekend getaways, the space offers a blend of comfort, convenience, and local charm — hosted by someone who knows how to make guests feel at home.</p>

//           {/* Features Row 1 */}
// <div className="flex flex-col sm:flex-row justify-between gap-10">
//   <div className="flex items-center gap-2 text-sm w-full sm:w-1/2">
//     <BedDouble />
//     <p>2 Bedrooms . 1 Bath . Sleeps 4</p>
//   </div>
//   <div className="flex items-center gap-2 text-sm w-full sm:w-1/2">
//     <MapPin />
//     <p>Lekki Phase 1, Lagos</p>
//   </div>
// </div>

// {/* Features Row 2 */}
// <div className="flex flex-col sm:flex-row justify-between gap-10">
//   <div className="flex items-center gap-2 text-sm w-full sm:w-1/2">
//     <Star />
//     <p>WiFi . AC . Kitchen . Parking</p>
//   </div>
//   <div className="flex items-center gap-2 text-sm w-full sm:w-1/2">
//     <Clock />
//     <p>Check-in: 2PM . Check-out: 11AM</p>
//   </div>
// </div>

// {/* Features Row 3 */}
// <div className="flex flex-col sm:flex-row justify-between gap-10">
//   <div className="flex items-center gap-2 text-sm w-full sm:w-1/2">
//     <DollarSign />
//     <p>325,000 / night</p>
//   </div>
//   <div className="flex items-center gap-2 text-sm w-full sm:w-1/2">
//     <Calendar />
//     <p>Weekdays & weekends (flexible schedule)</p>
//   </div>
// </div>

//           {/* Features Row 1 */}
//           {/* <div className="flex flex-col sm:flex-row justify-between gap-4">
//             <div className="flex items-center gap-2 text-sm">
//               <BedDouble />
//               <p>2 Bedrooms . 1 Bath . Sleeps 4</p>
//             </div>
//             <div className="flex items-center gap-2 text-sm">
//               <MapPin />
//               <p>Lekki Phase 1, Lagos</p>
//             </div>
//           </div> */}

//           {/* Features Row 2 */}
//           {/* <div className="flex flex-col sm:flex-row justify-between gap-4">
//             <div className="flex items-center gap-2 text-sm">
//               <Star />
//               <p>WiFi . AC . Kitchen . Parking</p>
//             </div>
//             <div className="flex items-center gap-2 text-sm">
//               <Clock />
//               <p>Check-in: 2PM . Check-out: 11AM</p>
//             </div>
//           </div> */}

//           {/* Features Row 3 */}
//           {/* <div className="flex flex-col sm:flex-row justify-between gap-4">
//             <div className="flex items-center gap-2 text-sm">
//               <DollarSign/>
//               <p>325,000 / night</p>
//             </div>

//             <div className="flex items-center gap-2 text-sm">
//               <Calendar />
//               <p>Weekdays & weekends (flexible schedule)</p>
//             </div>
//           </div> */}

//           {/* Buttons */}
//           <div className="flex flex-col sm:flex-row justify-between gap-4">
//             <button className="p-2 bg-[#570033] text-white w-full sm:w-[47%] rounded">
//               Book Now
//             </button>
//             <button className="text-[#570033] border border-[#570033] p-2 text-center rounded w-full sm:w-[47%]">
//               View Stay
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   export default StaysComponent;

import { useEffect, useState } from "react";
import {
  BedDouble,
  Calendar,
  Clock,
  DollarSign,
  MapPin,
  Star,
} from "lucide-react";
import axiosInstance from "../api/Axiosinstance";
import { ENDPOINTS } from "../api/Endpoints";

function StaysComponent() {
  const [stays, setStays] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    //   async function fetchStays() {
    //     try {
    //       const res = await fetch(
    //         "https://pulo-staging.onrender.com/api/tours/stays"
    //       );
    //       const data = await res.json();
    //       if (data.success && data.data?.results) {
    //         setStays(data.data.results);
    //       }
    //     } catch (error) {
    //       console.error("Error fetching stays:", error);
    //     } finally {
    //       setLoading(false);
    //     }
    //   }
    //   fetchStays();
    // }, []);

    async function fetchStays() {
      try {
        const res = await axiosInstance.get(ENDPOINTS.TOURS.STAYS);
        if (res.data.success && res.data.data?.results) {
          setStays(res.data.data.results);
        }
      } catch (error) {
        console.error("Error fetching stays:", error);
      } finally {
        setLoading(false);
      }
    }
    fetchStays();
  }, []);

  if (loading) {
    return <p className="text-center p-4">Loading stays...</p>;
  }

  return (
    <div>
      {stays.map((stay) => (
        <div
          key={stay.id}
          className="border border-[rgba(85,81,81,0.8)] flex flex-col md:flex-row justify-between items-start md:items-center gap-6 p-4 rounded my-4"
        >
          {/* Image */}
          <img
            src={stay.images?.[0]?.url || "/images/house1.png"}
            alt={stay.title}
            className="rounded w-full md:w-[30%] object-cover"
          />

          {/* Details */}
          <div className="flex flex-col w-full md:w-[70%] gap-6 justify-between">
            {/* Title & Rating */}
            <div className="flex flex-col sm:flex-row sm:justify-between gap-2">
              <p className="text-[#570033] text-xl font-semibold">
                {stay.title}
              </p>
              <span className="flex items-center gap-2 text-sm">
                <Star className="text-yellow-400" size={18} />
                <p className="text-[#570033] font-medium">
                  {stay.rating || "0.0"} ({stay.totalReviews} reviews)
                </p>
              </span>
            </div>

            {/* Description */}
            <p className="text-[#666666] text-sm leading-relaxed">
              {stay.description}
            </p>

            {/* Features Row 1 */}
            <div className="flex flex-col sm:flex-row justify-between gap-10">
              <div className="flex items-center gap-2 text-sm w-full sm:w-1/2">
                <BedDouble />
                <p>{stay.propertySummary}</p>
              </div>
              <div className="flex items-center gap-2 text-sm w-full sm:w-1/2">
                <MapPin />
                <p>{stay.locationSummary}</p>
              </div>
            </div>

            {/* Features Row 2 */}
            <div className="flex flex-col sm:flex-row justify-between gap-10">
              <div className="flex items-center gap-2 text-sm w-full sm:w-1/2">
                <Star />
                <p>
                  {stay.amenities?.length > 0
                    ? stay.amenities.join(" • ")
                    : "WiFi • AC • Kitchen • Parking"}
                </p>
              </div>
              <div className="flex items-center gap-2 text-sm w-full sm:w-1/2">
                <Clock />
                <p>
                  Check-in: {stay.checkIn?.time?.replace(":00", "")}PM •
                  Check-out: {stay.checkOut?.time?.replace(":00", "")}AM
                </p>
              </div>
            </div>

            {/* Features Row 3 */}
            <div className="flex flex-col sm:flex-row justify-between gap-10">
              <div className="flex items-center gap-2 text-sm w-full sm:w-1/2">
                <DollarSign />
                <p>{stay.formattedPrice}</p>
              </div>
              <div className="flex items-center gap-2 text-sm w-full sm:w-1/2">
                <Calendar />
                <p>{stay.availability?.schedule}</p>
              </div>
            </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row justify-between gap-4">
              <button className="p-2 bg-[#570033] text-white w-full sm:w-[47%] rounded">
                Book Now
              </button>
              <button className="text-[#570033] border border-[#570033] p-2 text-center rounded w-full sm:w-[47%]">
                View Stay
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default StaysComponent;
